import { z } from "zod";

import { XeroIntegrationFormValues } from "./types";

export const INITIAL_VALUES_XERO_INTEGRATION_FORM: XeroIntegrationFormValues = {
  clearing: "",
  payout: undefined,
  charge: undefined,
  refund: undefined,
  fee: undefined,
  adjustment: undefined,
  other: undefined,
};

const selectOptionSchema = z
  .object({
    id: z.union([z.string(), z.number()]),
    label: z.string(),
    value: z.string(),
  })
  .optional();

export const xeroIntegrationFormSchema = z
  .object({
    clearing: z.string({ required_error: "This field is required" }),
    payout: selectOptionSchema,
    charge: selectOptionSchema,
    refund: selectOptionSchema,
    fee: selectOptionSchema,
    adjustment: selectOptionSchema,
    other: selectOptionSchema,
  })
  .superRefine((data, ctx) => {
    const requiredFields: (keyof typeof data)[] = [
      "payout",
      "charge",
      "refund",
      "fee",
      "adjustment",
      "other",
    ];

    requiredFields.forEach((field) => {
      if (!data[field]) {
        ctx.addIssue({
          path: [field],
          code: z.ZodIssueCode.custom,
          message: "This field is required",
        });
      }
    });
  });
